/*satis.12yazilim@gmail.com
 https://www.burdanbi.com/login/google/callback
 */
export const Config = {
    googleOAuthClientId:'154182098127-sd5a97kvife26p9dfcb34mbse54ofenr.apps.googleusercontent.com',
    gAnalyticsId: 'UA-164264610-2',
    apiHost: 'https://site.burdanbi.com:33103/'
}